// utils/recommendationEngine.js
export const getTopRecommendedTopic = (subjects = []) => {
  let allTopics = [];

  // Flatten topics from all regular subjects (skipping quests)
  subjects.forEach((subject) => {
    if (subject?.subjectType?.toLowerCase() === 'quests' || subject?.subjectType?.toLowerCase() === 'foundation') {
      return; // Skip Side Quests from hero recommendations
    }

    (subject.Topics || []).forEach((topic) => {
      allTopics.push({
        ...topic,
        subjectName: subject.name || topic.subjectName || 'General',
        subjectColor: subject.color || '#6366f1',
      });
    });
  });

  if (allTopics.length === 0) return null;

  // Score each topic (higher score = higher priority)
  const scoredTopics = allTopics.map((topic) => {
    const attempts = topic.attemptsCount ?? topic.attempts ?? 0;
    const level = topic.currentLevel ?? topic.level ?? 1;
    const isMastered = topic.isMastered || topic.completed || level >= 5;

    let priority = 0;
    let badgeText = 'Recommended';

    // 1. Mastered topics get minimal priority
    if (isMastered) {
      return { ...topic, priority: -10, badgeText: 'Mastered' };
    }

    // 2. High priority: Struggling / Plateaued (High attempts, low level)
    if (attempts >= 4 && level <= 2) {
      priority += 100 + attempts * 2;
      badgeText = 'Power-Up';
    } 
    // 3. Spaced repetition: Inactive for 5+ days
    else if (topic.lastAttemptedAt) {
      const daysSince = Math.floor(
        (Date.now() - new Date(topic.lastAttemptedAt).getTime()) / (1000 * 60 * 60 * 24)
      );
      if (attempts > 0 && daysSince >= 5) {
        priority += 70 + daysSince * 3;
        badgeText = 'Memory Boost';
      } else if (attempts > 0) {
        // Steady in-progress
        priority += 40 + level * 5;
        badgeText = 'Level Up';
      }
    } 
    // 4. Fresh / Unattempted Core topics
    else {
      priority += 50;
      badgeText = 'New Topic';
    }

    return { ...topic, priority, badgeText };
  });

  // Sort descending by priority score
  scoredTopics.sort((a, b) => b.priority - a.priority);

  return scoredTopics[0] || null;
};